/**
 * Issue #2006: the refusal the identity provider sent back on the redirect (AADSTS500011, a
 * cancel), kept by `getMsalApp` while nobody is signed in, so the sign-in page shows its sentence
 * beside every way to sign in instead of the "unavailable" Retry. Its own module so the tests
 * that mock `msalTokenProvider` keep this real. `takeRedirectRefusal` reads it once.
 */
let redirectRefusal: Error | null = null;

export function keepRedirectRefusal(refusal: Error): void {
  redirectRefusal = refusal;
}

/** The redirect's refusal, once; null when the redirect brought none back. */
export function takeRedirectRefusal(): Error | null {
  const refusal = redirectRefusal;
  redirectRefusal = null;
  return refusal;
}
